<template>
  <div>
    <b-tabs class="nav-tabs-underline mt-3" content-class="mt-3">
      <b-tab
        :title="tab.name"
        :active="currentTab === tab.name"
        @click="selectTab(tab.path)"
        v-for="tab in tabs"
        :key="tab.path"
      >
        <router-view></router-view>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        { name: 'Distributors', path: '' },
        { name: 'Plans', path: 'plans' },
        { name: 'Follow Ups', path: 'followups' }
      ],
      currentTab: this.$route.name.split('/').pop()
    };
  },
  components: {
    Distributors: () => import('./List.vue'),
    Plans: () => import('./Plans.vue')
  },
  methods: {
    selectTab(path) {
      this.$router.push({ path: `/admin/distributors/${path}` });
    }
  },
  watch: {
    $route(to, from) {
      this.currentTab = to.name.split('/').pop();
    }
  }
};
</script>
